var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoSmallBalls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 25,
    viewBox: "0 0 57 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0493 22.4433C8.37229 23.4844 2.92619 19.7263 1.88509 14.0493C0.843977 8.3723 5.50009 2.76152 10.2791 1.88509C15.9561 0.843986 21.4022 4.60211 22.4433 10.2791C23.4844 15.9561 19.7263 21.4022 14.0493 22.4433Z",
    fill: "#FF9C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0493 22.4433C40.3723 23.4844 34.9262 19.7263 33.8851 14.0493C32.844 8.3723 37.5001 2.76152 42.2791 1.88509C47.9561 0.843986 53.4022 4.60211 54.4433 10.2791C55.4844 15.9561 51.7263 21.4022 46.0493 22.4433Z",
    fill: "#FF9C00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoSmallBalls);
export default __webpack_public_path__ + "static/media/two-small-balls.6d05fbad1b8a2c18614ee43f08d9b539.svg";
export { ForwardRef as ReactComponent };